export class Place{
  id?: string;
  floor?: string;
  name?: string;
  stallsLabel?: string;

  constructor(params?: Partial<Place>) {
    Object.assign(this, params);
  }
}